import { useContext } from 'react'
import PropTypes from 'prop-types'
import { ValidationContext } from './validationContext'

function ValidationResult ({ render }) {
  const value = useContext(ValidationContext)
  return value
    ? render({ isValid: value.errors.length === 0, errors: value.errors })
    : render({ isValid: true })
}

const useValidationResult = () => {
  const value = useContext(ValidationContext)
  return value
    ? { isValid: value.errors.length === 0, errors: value.errors } 
    : { isValid: true }
}

ValidationResult.propTypes = {
  render: PropTypes.func.isRequired
}

export {
  ValidationResult,
  useValidationResult
}